import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger, Observer} from "../LibrariesImport";

export default class BlockContentNavFixed {
	static init() {

		this.blocks = document.querySelectorAll(".block-content-nav-fixed, .block-lexique");
		this.blocks.forEach( block => {

			const navs = block.querySelectorAll('.subnav-container li');
			const items = block.querySelectorAll('.item');
			const container = block.querySelector('.item-container');

			const subnavUl = block.querySelector('.subnav-container ul');
			const parent   = subnavUl.parentElement;

			const navMain = document.querySelectorAll(".nav-main a");

			ScrollTrigger.create({
				trigger: container,
				start: "top top",
				end: "bottom bottom",
				onUpdate: (e) => {
					const contentHeight = subnavUl.offsetHeight;
					const parentHeight  = parent.offsetHeight;
					const maxTranslatePercent = ((contentHeight - parentHeight) / contentHeight) * 100;
					gsap.set(subnavUl, {
						yPercent: -e.progress * maxTranslatePercent
					});
				}
			});

			items.forEach( (item, index) => {
				ScrollTrigger.create({
					trigger: item,
					start: "top center",
					end: "bottom center",
					onToggle: () => {
						navs.forEach( nav => {
							nav.classList.remove('active');
						});
						navs[index].classList.add('active');
						navMain.forEach( nav => {
							nav.closest('li').classList.remove('current-menu-item');
							if( nav.hash.substring(1) === item.id ){
								nav.closest('li').classList.add('current-menu-item');
							}
						});
					}
				});
			});


			navs.forEach( (nav, i) => {
				nav.addEventListener('click', function (event) {

					nav.querySelector('a').addEventListener('click', (e) => {
						e.preventDefault();
					});

					const anchor = nav.querySelector('a').getAttribute('href');
					const targetElement = document.getElementById(anchor.substring(1));


					if (targetElement) {
						targetElement.classList.add('highlight');
						const elTop = targetElement.getBoundingClientRect().top + window.scrollY;
						const target = elTop - (window.innerHeight / 2) + (targetElement.offsetHeight / 2);
						GlobalVariables.lenis.scrollTo(target);
						setTimeout( ()  => {
							targetElement.classList.remove('highlight');
						}, 900);
					}

				});
			});

		});

	}

}
